
// Globals 
export const ACCORDION_SELECTOR = '[data-component="collapsible"]';
export const ACCORDION_TOGGLE_ALL_BTN = 'button[data-click="collapsibleToggleAll"]';
export const ACCORDION_ITEM_SELECTOR = '.accordion__item';
export const ACCORDION_ACTIVE_ITEM_SELECTOR = '.accordion__item--active';
export const ACCORDION_ITEM_TOGGLE_BTN = 'button[data-click="collapsibleToggle"]';
export const ACCORDION_ITEM_BODY = '.accordion__body';
export const ACCORDION_AUTO_CLOSE = 'data-auto-close';
export const ACCORDION_ACTIVE_CLASS = 'accordion__item--active';

/**
 * Check if toggle all button should be updated
 * @param {HTMLElement} section - The accordion section DOM Element
 */
export function checkIfAllOpen(items, toggleAllBtn) {
    const openItems = [];

    items.forEach(item => {
        const isExpanded = item.querySelector(ACCORDION_ITEM_TOGGLE_BTN).getAttribute('aria-expanded') === 'true';
        if(isExpanded) {
            openItems.push(true);
        }
    })

    const isAllExpanded = openItems.length === items.length ? true : false;                 
    updateButtonLabel(toggleAllBtn, isAllExpanded);
}

/**
 * Update HTML of toggle all button 
 * @param {HTMLElement} btn - The accordion toggle all items DOM Element
 * @param {boolean} isExpanded - The flag if all items are expanded
 */
export function updateButtonLabel(btn, isExpanded) {
    btn.setAttribute('aria-expanded', isExpanded);
    btn.innerHTML = isExpanded ? btn.getAttribute('data-collapse-label') : btn.getAttribute('data-expand-label');
}

/**
 * Update the state of accoridon item
 * @param {HTMLElement} item - The accordion item DOM Element
 * @param {boolean} isExpanded - The flag if item is expanded
 */
export function toggleActiveState(item, isExpanded) {
    if (isExpanded) {
        item.classList.remove(ACCORDION_ACTIVE_CLASS);
        item.querySelector(ACCORDION_ITEM_TOGGLE_BTN).setAttribute('aria-expanded', !isExpanded);
        item.querySelector(ACCORDION_ITEM_BODY).style.maxHeight = null;
        item.querySelector(ACCORDION_ITEM_BODY).setAttribute('aria-hidden', 'true');
        item.querySelector(ACCORDION_ITEM_BODY).setAttribute('inert', true);
    } else {
        item.classList.add(ACCORDION_ACTIVE_CLASS);
        item.querySelector(ACCORDION_ITEM_TOGGLE_BTN).setAttribute('aria-expanded', !isExpanded);
        item.querySelector(ACCORDION_ITEM_BODY).setAttribute('aria-hidden', 'false');
        item.querySelector(ACCORDION_ITEM_BODY).removeAttribute('inert');
        item.querySelector(ACCORDION_ITEM_BODY).style.maxHeight = Math.ceil(item.querySelector(ACCORDION_ITEM_BODY).scrollHeight + 24) + "px";
    }
}

/**
 * Event handler for accordion toggle all button click
 * @param {HTMLElement} toggleAllBtn - The accordion toggle all items DOM Element
 * @param {HTMLElement} items - The accordion items DOM Element
 */
export function toggleAllItems(toggleAllBtn, items) {
    toggleAllBtn.addEventListener('click', function () {
        const isExpanded = toggleAllBtn.getAttribute('aria-expanded') === 'true';

        items.forEach(item => {
            toggleActiveState(item, isExpanded);
        });

        updateButtonLabel(toggleAllBtn, !isExpanded)
    });
}

/**
 * Event handler for accordion item click
 * @param {HTMLElement} items - The accordion items DOM Element
 * @param {string} autoClose - The accordion section data-auto-close attribute
 */
export function toggleItem(items, autoClose, toggleAllBtn) {
    items.forEach(item => {
        const btn = item.querySelector(ACCORDION_ITEM_TOGGLE_BTN);
        btn.addEventListener('click', function () {
            const isExpanded = this.getAttribute('aria-expanded') === 'true';    
            if (autoClose) {
                items.forEach(el => {
                    toggleActiveState(el, true);
                })
                toggleActiveState(item, isExpanded);
            } else {
                toggleActiveState(item, isExpanded);

                if (toggleAllBtn) {
                    checkIfAllOpen(items, toggleAllBtn);
                }
            }
        });
    });
}

/**
 * Set elements max heigh function for accoridon active items
 * @param {HTMLElement} activeItems - The accordion active items DOM Elements
 */
export function setInitialHeight(activeItems)  {
    activeItems.forEach(active => {
        const activeBody = active.querySelector(ACCORDION_ITEM_BODY);
        activeBody.style.maxHeight = Math.ceil(activeBody.scrollHeight + 24) + "px";
    })
}

/**
 * Init function for accoridon instance
 * @param {HTMLElement} section - The accordion section DOM Element
 */
export function _init(section) {
    // Globals
    const toggleAllBtn = section.querySelector(ACCORDION_TOGGLE_ALL_BTN);
    const items = section.querySelectorAll(ACCORDION_ITEM_SELECTOR);
    const autoClose = section.getAttribute(ACCORDION_AUTO_CLOSE);
    const activeItems = section.querySelectorAll(ACCORDION_ACTIVE_ITEM_SELECTOR);
    console.log('items', items);
    

    // Bind event handler for all items btn 
    if(toggleAllBtn) { 
        toggleAllItems(toggleAllBtn, items);
    }
    // Bind event hendler for accordion item btn 
    toggleItem(items, autoClose, toggleAllBtn);

    // Set the max height for active items after DOM loads
    setInitialHeight(activeItems);
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll(ACCORDION_SELECTOR).forEach(section => {
        _init(section);
    });
});

window.addEventListener('resize', function () {
    document.querySelectorAll(ACCORDION_SELECTOR).forEach(section => {
        const activeItems = section.querySelectorAll(ACCORDION_ACTIVE_ITEM_SELECTOR);
        setInitialHeight(activeItems);
    });
});